module.exports = __webpack_public_path__ + "3440ce94fab3fcd9f834e1b967d39248.pdf";